module.exports = __webpack_public_path__ + "e58b0ba89bb2667798466234553eed18.svg";